module.exports = __webpack_public_path__ + "img/knowledge-2.af6bd4ed.png";